import { Enum, EnumType } from 'ts-jenum';

@Enum<LineStateEnum>('value')
export class LineStateEnum extends EnumType<LineStateEnum>() {
   static readonly NONE = new LineStateEnum('None', false, false, false, 0);
   static readonly IDLE = new LineStateEnum('Idle', false, false, false, 1);
   static readonly OFFERING = new LineStateEnum('Offering', false, false, false, 2);
   static readonly ACCEPTED = new LineStateEnum('Accepted', false, true, false, 4);
   static readonly DIALTONE = new LineStateEnum('Dialtone', true, false, false, 8);
   static readonly DIALING = new LineStateEnum('Dialing', true, false, false, 16);
   static readonly RINGBACK = new LineStateEnum('Ringback', true, false, false, 32);
   static readonly BUSY = new LineStateEnum('Busy', true, false, false, 64);
   static readonly CONNECTED = new LineStateEnum('Connected', true, false, true, 256);
   static readonly PROCEEDING = new LineStateEnum('Proceeding', true, false, false, 512);
   static readonly ON_HOLD = new LineStateEnum('OnHold', true, false, true, 1024);
   static readonly CONFERENCED = new LineStateEnum('Conferenced', true, false, true, 2048);
   static readonly ON_HOLD_PENDING_CONFERENCE = new LineStateEnum('OnHoldPendingConference', true, false, true, 4096);
   static readonly ON_HOLD_PENDING_TRANSFER = new LineStateEnum('OnHoldPendingTransfer', true, false, true, 8192);
   static readonly DISCONNECTED = new LineStateEnum('Disconnected', true, false, false, 16384);
   static readonly UNKNOWN = new LineStateEnum('Unknown', false, false, false, 39321); // -1

   public static fromEnumValue(value: number): LineStateEnum {
      return LineStateEnum.find((e) => e.enumValue === value) ?? LineStateEnum.UNKNOWN;
   }

   private constructor(
      public value: string,
      public isCallInProgress: boolean,
      public isRinging: boolean,
      public isConnected: boolean,
      public enumValue: number
   ) {
      super();
   }
}
